export default function MurfreesboroLocalAreaSection() {
  return (
    <section id="local-area" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Local Coverage</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Serving Murfreesboro & Surrounding Areas
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            We cover all of Rutherford County and serve the entire Nashville metro south corridor.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-14">
          <div className="bg-white rounded-xl overflow-hidden">
            <div className="h-48 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Middle%20Tennessee%20State%20University%20MTSU%20campus%20aerial%20view%20with%20modern%20buildings%20and%20green%20quad%20areas%2C%20bright%20sunny%20day%20in%20Murfreesboro%20Tennessee%2C%20college%20campus%20photography%20with%20warm%20natural%20lighting&width=800&height=400&seq=murfreesboro-local1&orientation=landscape"
                alt="Middle Tennessee State University"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="p-6">
              <h3 className="font-serif text-xl font-bold text-[#1A365D] mb-2">Middle Tennessee State University</h3>
              <p className="text-gray-500 text-sm leading-relaxed">
                MTSU is home to over 20,000 students with robust study abroad programs. We specialize in semester deadline passport processing, student group applications, and international teaching placement documentation.
              </p>
            </div>
          </div>
          <div className="bg-white rounded-xl overflow-hidden">
            <div className="h-48 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Historic%20Murfreesboro%20Tennessee%20town%20square%20with%20Rutherford%20County%20courthouse%20and%20charming%20small%20business%20district%2C%20green%20trees%20lining%20the%20streets%2C%20warm%20sunny%20day%20editorial%20photography%20with%20natural%20colors&width=800&height=400&seq=murfreesboro-local2&orientation=landscape"
                alt="Murfreesboro Town Square"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="p-6">
              <h3 className="font-serif text-xl font-bold text-[#1A365D] mb-2">Rutherford County Growth Corridor</h3>
              <p className="text-gray-500 text-sm leading-relaxed">
                Tennessee's fastest-growing county. We serve the booming professional population commuting to Nashville, Nissan Smyrna employees, and families in expanding neighborhoods like Blackman and Barfield.
              </p>
            </div>
          </div>
        </div>

        {/* Coverage areas */}
        <div className="bg-white rounded-xl p-8">
          <h3 className="font-serif text-xl font-bold text-[#1A365D] mb-6 text-center">Areas We Serve</h3>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
            {[
              "Murfreesboro",
              "Smyrna",
              "La Vergne",
              "Christiana",
              "Rockvale",
              "Lascassas",
              "Kittrell",
              "Eagleville",
              "Walterhill",
              "Blackman",
              "Barfield",
              "Florence",
            ].map((area, i) => (
              <div key={i} className="flex items-center gap-2 bg-[#F7F8FA] px-4 py-3 rounded-lg">
                <i className="ri-map-pin-2-line text-[#F6C344] text-sm"></i>
                <span className="text-[#1A365D] text-sm font-medium">{area}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}